var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AddressEdit',{attrs:{"area-list":_vm.areaList,"default-region":_vm.defaultRegion,"show-delete":_vm.isEdit,"show-set-default":"","show-search-result":"","area-columns-placeholder":['请选择', '请选择', '请选择'],"address-info":_vm.addressInfo},on:{"save":_vm.onSave,"delete":_vm.onDelete,"change-detail":_vm.onChangeDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }